import React, { useEffect, useState } from 'react'
import { get_departments } from '../../../helper/Api';
import DataTable from 'react-data-table-component';
import { useDispatch, useSelector } from 'react-redux';
import { GET_DEPARTMENT_FAIL, GET_DEPARTMENT_START, GET_DEPARTMENT_SUCCESS } from '../../../RTK/Slices/DepartmentSlice';
import { FaRegEdit } from "react-icons/fa"
import { Link } from 'react-router-dom';
import './ManageDepartment.css';

const ManageDepartment = ({searchStr, tier}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const { authData } = useSelector((state) => state.authData);
  const dispatch = useDispatch();
  const [departments, setDepartments] = useState([]);
  const fetchDepartments = async () => {
    try {
      const departments = await get_departments({ department_level: tier, searchStr: searchStr, parent_department_id: authData.user.department_id != 1 ? authData.user.department_id : null });
      if (departments.data.status) {
        setDepartments(departments.data.result);
      } 
    } catch (error) {
      console.log("get_departments error", error);
    }
  }

  useEffect(() => {
    fetchDepartments();
  }, [dispatch, searchStr, tier])

  const customStyles = {
    headCells: {
      style: {
        fontWeight: "bold",
        fontSize: "14px"
      },
    },
  };

  const columns = [
    {
      name: 'Code',
      selector: (row) => row.code,
      sortable: true,
    },
    {
      name: 'Name',
      selector: (row) => row.name,
      sortable: true,
      wrap: true
    },
    {
      name: 'Department Level',
      selector: (row) => row.nomiclature,
      sortable: true,
      wrap: true,
      // width:"100px"
    },
    {
      name: 'Tier',
      selector: (row) => row.department_level,
      sortable: true,
      wrap: true,
      // width:"100px"
    },
    {
      name: 'Parent Dept. Name',
      selector: (row) => row.parent_department_name,
      sortable: true,
      wrap: true,
      // width:"100px"
    },
    {
      name: 'Parent Dept. Tier',
      selector: (row) => row.parent_department_level,
      sortable: true,
      wrap: true,
      // width:"100px"
    },
  ];
  if(authData.user.user_type === 'l3') {
    columns.push({
      name: 'Action',
      width: "200px",
      selector: (row) => {
        return (
          <div className='user_action'>
            <span className='pr-4'><Link to={`/edit-department/${row.id}`}><FaRegEdit /></Link></span>
          </div>
        );
      },
      sortable: true,
    });
  }
  const handleChangeRowsPerPage = (currentRowsPerPage, currentPage) => {
    setRowsPerPage(currentRowsPerPage);
    setCurrentPage(1);
  };
  return (
    <div>
      <DataTable
        customStyles={customStyles}
        className="dataTables_wrapper"
        columns={columns}
        data={departments}
        fixedHeader
        fixedHeaderScrollHeight="600px"
        pagination
        paginationPerPage={rowsPerPage}
        paginationTotalRows={departments.length}
        paginationRowsPerPageOptions={[10, 25, 50, 100]}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </div>
  )
}

export default ManageDepartment
